module.exports = __webpack_public_path__ + "static/media/PM112.b7c454a9.png";